import { Result } from '@standardnotes/domain-core';
import { CreateEncryptedBackupFileContextPayload } from '@standardnotes/models';
import { ProtocolVersionLatest } from '@standardnotes/common';
import { CreateEncryptionSplitWithKeyLookup, SplitPayloadsByEncryptionType } from '@standardnotes/encryption';
export class CreateEncryptedBackupFile {
    constructor(items, protections, encryption) {
        this.items = items;
        this.protections = protections;
        this.encryption = encryption;
    }
    async execute(params = { skipAuthorization: false }) {
        if (!params.skipAuthorization && !(await this.protections.authorizeBackupCreation())) {
            return Result.fail('Failed to authorize backup creation');
        }
        const payloads = this.items.items.map((item) => item.payload);
        const split = SplitPayloadsByEncryptionType(payloads);
        const keyLookupSplit = CreateEncryptionSplitWithKeyLookup(split);
        const result = await this.encryption.encryptSplit(keyLookupSplit);
        const ejected = result.map((payload) => CreateEncryptedBackupFileContextPayload(payload));
        const data = {
            version: ProtocolVersionLatest,
            items: ejected,
        };
        const keyParams = this.encryption.getRootKeyParams();
        data.keyParams = keyParams === null || keyParams === void 0 ? void 0 : keyParams.getPortableValue();
        return Result.ok(data);
    }
}
